@let all = entries();
@if (file.isLoading()) {
  <p class="licenses__state">{{ 'Loading...' | translate }}</p>
} @else if (!all.length) {
  <p class="licenses__state">
    {{ 'License information is included in release builds.' | translate }}
  </p>
} @else {
  @let shown = filtered();
  <div class="licenses__toolbar">
    <input
      #filter
      type="search"
      class="licenses__filter"
      [value]="query()"
      [placeholder]="'Filter packages' | translate"
      [attr.aria-label]="'Filter packages' | translate"
      (input)="query.set(filter.value)" />
    <span class="licenses__count">{{ '[count] packages' | translate: { count: all.length } }}</span>
  </div>
  <ul class="licenses__list">
    @for (entry of shown; track entry) {
      <li>
        <details class="license">
          <summary class="license__summary">
            <span class="license__name">{{ entry.name }}</span>
            <span class="license__chip">{{ entry.license ?? ('Other' | translate) }}</span>
          </summary>
          @if (entry.text) {
            <pre class="license__text">{{ entry.text }}</pre>
          } @else {
            <p class="license__empty">{{ 'No license text included.' | translate }}</p>
          }
        </details>
      </li>
    }
  </ul>
}
